import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useIsSellerFeatureEnabled = (featureCode) => {
  const sellerFeatures = useSelector(Global.selectSellerSellerFeatures);

  const enabledFeaturesAndAddOnsCodes = new Set(sellerFeatures);
  return enabledFeaturesAndAddOnsCodes.has(featureCode);
};
